export const SITE = {
  name: "A2Z Rankings",
  // Single production canonical domain (www). Host-level apex→www and HTTP→HTTPS
  // 301 redirects are configured at deploy/CDN level, not in app code.
  domain: "https://www.a2zrankings.com",
  email: "info@a2zrankings.com",
  phone: "+91 6389095473",
  phoneHref: "tel:+916389095473",
  indiaOffice:
    "4th Floor, A-355, New Panchwati Colony, Ghaziabad, Uttar Pradesh, India – 201001",
  primaryMarket: "Australia",
  markets: ["Australia", "India", "USA", "UK", "Canada"],
  tagline: "Technology, Software & Digital Growth Agency",
  // Social profiles: real URLs pending — set here once provided, never hardcode elsewhere.
  socials: [
    { label: "LinkedIn", href: "#" },
    { label: "X", href: "#" },
    { label: "Instagram", href: "#" },
    { label: "YouTube", href: "#" },
  ],
};

export const SERVICE_CATEGORIES = [
  {
    slug: "software-web-development",
    name: "Software & Web Development",
    blurb: "Custom software, websites, web apps, SaaS and e-commerce builds.",
    services: 8,
  },
  {
    slug: "mobile-app-development",
    name: "Mobile App Development",
    blurb: "iOS, Android and cross-platform apps designed for retention.",
    services: 5,
  },
  {
    slug: "ai-automation",
    name: "AI & Automation Solutions",
    blurb: "AI integrations, chatbots and workflow automation that save hours.",
    services: 6,
  },
  {
    slug: "seo-digital-growth",
    name: "SEO & Digital Growth",
    blurb: "SEO, GEO, paid media, content and conversion optimisation.",
    services: 10,
  },
  {
    slug: "uiux-creative-design",
    name: "UI/UX & Creative Design",
    blurb: "Product design, brand identity and conversion-focused interfaces.",
    services: 6,
  },
];

export const NAV_LINKS = [
  { label: "Work", href: "/work", testid: "nav-link-work" },
  { label: "About", href: "/about", testid: "nav-link-about" },
  { label: "Resources", href: "/resources", testid: "nav-link-resources" },
  { label: "Contact", href: "/contact", testid: "nav-link-contact" },
];
